import Axios from 'axios';
// noinspection ES6UnusedImports
import bootstrap from 'bootstrap';
import {initHome} from './home/home';
import {
    initNavbar
} from './navbar/navbar';
import {initProductView} from "./products/product";

// Import swiper css
import 'swiper/swiper-bundle.css';


Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const routes = [
    {
        test: /\/\/[^/]*\/?$/, // Matches root of site with or without /
        action: initHome,
    },
    {
        test: /categorias\/[^/]*\/[^/]*$/, // Matches categorias/[categoria]/[product]
        action: initProductView,
    }
];

document.addEventListener('DOMContentLoaded', () => {
    initNavbar();

    let url = window.location.href.split('?')[0]; // Remove query
    url = url.replace('#', ''); // remove hash

    routes.forEach(route => {
        if (url.match(route.test)) { // Check matching routes
            route.action();
        }
    })
})